<template>
  <div class="customer-list clearfix"
       style="display: flex">
    <div class="customer-table-list fr">
      <Search @getHeight="getHeight"
              @saveSet="saveSet"
              :isquery="true"
              :tableConfig="tableConfig"
              :advancedQuery="true"
              :isSort="false"
              :functionBtn="true"
              :isDel="false"
              :isAdd="false"
              :showDel="false"
              :showSort="false"
              :showAdd="false"
              ref="Search"
              searchName="ServiceRecommendLogPage">
        <template v-slot:left>
          <el-col :lg="12"
                  :md="12"
                  :sm="12"
                  :xs="12">
            <el-form-item label="申请银行">
              <el-select filterable
                         v-model="searchForm.bankId"
                         clearable
                         style="width: 100%"
                         placeholder="请选择申请银行">
                <el-option v-for="item in BankList"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="12"
                  :md="12"
                  :sm="12"
                  :xs="12">
            <el-form-item label="关键字">
              <el-input v-model="searchForm.keyWord"
                        clearable
                        @keyup.enter.native="$refs.Search.handleSearch"
                        placeholder="请输入关键字查询"></el-input>
            </el-form-item>
          </el-col>
        </template>
        <template v-slot:center>
          <el-button size="small "
                     icon="el-icon-back"
                     type="success"
                     plain
                     @click="noteCard">前往开户</el-button>
        </template>
        <template v-slot:advancedQuery>
          <el-col :lg="8"
                  :md="10"
                  :sm="12"
                  :xs="24">
            <el-form-item label="申请时间"
                          label-width="120px">
              <el-col :span="11">
                <el-date-picker style="width: 100%"
                                v-model="searchForm.createStartDate"
                                value-format="yyyy-MM-dd"
                                type="date"
                                placeholder="选择开始日期">
                </el-date-picker>
              </el-col>
              <el-col :span="2">~</el-col>

              <el-col :span="11">
                <el-date-picker style="width: 100%"
                                v-model="searchForm.createEndDate"
                                value-format="yyyy-MM-dd"
                                type="date"
                                placeholder="选择结束日期">
                </el-date-picker>
              </el-col>
            </el-form-item>
          </el-col>
          <!-- <el-col :lg="4" :md="6" :sm="12" :xs="24">
            <el-form-item label="状态">
              <el-select
                filterable
                v-model="searchForm.openCardState"
                clearable
                style="width: 100%"
                placeholder="请选择状态"
              >
                <el-option label="正常" :value="1"></el-option>
                <el-option label="异常" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
        </template>
      </Search>
      <MyTable :tableData="tableData"
               :tableConfig="tableConfig"
               :height="tableHeight"
               tableType="selection"
               @selectionChange="handleSelectionChange"
               :indexFlag="true">
        <template v-slot:index="slotData">
          {{
            ($refs.pagination.currentPage - 1) * $refs.pagination.pageSize +
            slotData.scope.$index +
            1
          }}
        </template>
        <template v-slot:isStop="slotData">
          {{ slotData.scope.row.isStop ? "停用" : "启用" }}
        </template>
        <template v-slot:openCardState="slotData">
          {{
            slotData.scope.row.openCardState == 1
              ? "正常"
              : slotData.scope.row.openCardState == 2
              ? "异常"
              : ""
          }}
        </template>
        <template v-slot:createDate="slotData">
          {{
            slotData.scope.row.createDate &&
            slotData.scope.row.createDate.slice(0, 10)
          }}
        </template>
        <template v-slot:qrCodeUrl="slotData">
          <div v-if="slotData.scope.row.qrCodeUrl"
               @click="openDialog(slotData.scope.row.qrCodeUrl)"
               style="text-decoration: underline; cursor: pointer; color: #409eff">
            点击查看
          </div>
        </template>
      </MyTable>
      <Pagination class="PagPosition"
                  :total="total"
                  @getNewData="ServiceRecommendLogPage"
                  ref="pagination" />

      <el-dialog title="设置状态"
                 :visible.sync="stateDialogVisible"
                 :close-on-click-modal="false"
                 :close-on-press-escape="false"
                 width="400px"
                 class="colleague-dialog"
                 @close="resetForm">
        <el-form ref="form"
                 :model="form"
                 :inline="true"
                 :rules="rules"
                 label-width="auto"
                 v-enterToNext="true">
          <el-col :span="24">
            <el-form-item label="状态"
                          prop="state">
              <el-radio-group v-model="form.state">
                <el-radio label="1">正常</el-radio>
                <el-radio label="2">异常</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注"
                          prop="remark">
              <el-input style="width: 150%"
                        type="textarea"
                        :rows="4"
                        placeholder="请输入备注"
                        v-model="form.remark">
              </el-input>
            </el-form-item>
          </el-col>
        </el-form>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="
              () => {
                resetForm();
                stateDialogVisible = false;
              }
            ">关 闭</el-button>
          <el-button size="small "
                     type="primary"
                     :loading="submitLoading"
                     @click="SetOpenCarState('form')">确 定</el-button>
        </span>
      </el-dialog>
      <!-- <el-dialog
        title="通知开卡"
        :visible.sync="noticeDialogVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="400px"
        class="colleague-dialog"
        @close="resetForm"
      >
        <el-form
          ref="form"
          :model="form"
          :inline="true"
          :rules="rules"
          label-width="auto"
          v-enterToNext="true"
        >
          <el-col :span="24">
            <el-form-item label="开卡银行" prop="BankName">
              <el-select v-model="form.BankName" placeholder="请选择开卡银行">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button
            @click="
              () => {
                resetForm();
                noticeDialogVisible = false;
              }
            "
            >关 闭</el-button
          >
          <el-button
            size="small "
            type="primary"
            :loading="submitLoading"
            @click="onSubmit('form')"
            >确 定</el-button
          >
        </span>
      </el-dialog> -->
    </div>
    <el-dialog title="申请二维码"
               :visible.sync="QRVisible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="400px"
               center
               @close="closeDialog">
      <div style="display: flex; justify-content: center">
        <div v-if="QRVisible"
             id="qrcode"
             ref="qrcode"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Search from "@/components/Search";
import MyTable from "@/components/Table";
import QRCode from "qrcodejs2";

import { verifyPermissionMinix } from "@/utils/mixin";
export default {
  components: {
    Search,
    MyTable,
  },
  mixins: [verifyPermissionMinix],
  data () {
    return {
      tableName: "personalLoans_manage",
      tableConfig: [
        {
          field: "userName",
          label: "姓名",
          align: "center",

          flag: true,
        },
        {
          field: "tel",
          label: "手机号码",
          align: "center",

          flag: true,
        },
        {
          field: "identityCard",
          label: "身份证",
          align: "center",

          flag: true,
        },
        {
          field: "createDate",
          label: "申请时间",
          slotName: "createDate",
          align: "center",
          flag: true,
        },
        {
          field: "bankName",
          label: "申请银行",
          align: "center",
          flag: true,
        },
        {
          field: "bankBusinessName",
          label: "申请产品",
          align: "center",
          flag: true,
        },
        // {
        //   field: "qrCodeUrl",
        //   label: "申请二维码",
        //   slotName: "qrCodeUrl",
        //   align: "center",
        //   flag: true,
        // },
      ],
      form: {},
      rules: {
        BankName: [
          {
            required: true,
            message: "请选择通知银行",
            trigger: ["blur", "change"],
          },
        ],
        state: [
          {
            required: true,
            message: "请选择状态",
            trigger: "change",
          },
        ],
      },
      checked: true,
      id: "",
      tableHeight: "",
      submitLoading: false,
      stateDialogVisible: false,
      noticeDialogVisible: false,
      importVisible: false,
      userForm: {},
      QRVisible: false,
      companyList: [],
      options: [],
      Ids: [],
      searchList: [],
      total: 0,
      loading: false,
      tableData: [],
      searchForm: {},
      customerIds: [],
      companyId: "",
      BankList: [],
    };
  },
  mounted () {
    this.ServiceRecommendLogPage();
    this.getBankList();

    // this.getCompanyList();
    //初始化设置列的隐藏和排序方法
    if (localStorage.getItem(this.tableName)) {
      this.tableConfig = JSON.parse(localStorage.getItem(this.tableName));
      this.sortType = this.tableConfig.pop();
      this.tableConfig.forEach((element) => {
        if (element.sortable) {
          element.sortable = this.sortType;
        }
      });
    }
  },
  methods: {
    closeDialog () {
      document.getElementById("qrcode").innerHTML = "";
    },
    // 打开并生成二维码
    openDialog (res) {
      this.QRVisible = true;

      this.$nextTick(() => {
        this.qrcode(res);
      });
    },
    qrcode (res) {
      let qrcode = new QRCode("qrcode", {
        width: 150, // 设置宽度，单位像素
        height: 150, // 设置高度，单位像素
        text: res,
        // 设置二维码内容或跳转地址
      });
      console.log(qrcode);
    },
    SendMsgAgain () {
      let sendData = this.Ids;
      this.$api.user.CompanyReferrerCarSendMsgAgain(sendData).then((res) => {
        if (res.error === false) {
          this.$message.success("通知成功");
          this.ServiceRecommendLogPage();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 刷新状态
    refreshState () {
      let sendData = [];
      this.$api.user.CompanyReferrerCarRefreshState(sendData).then((res) => {
        if (res.error === false) {
          this.$message.success("刷新成功");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    confirm () {
      let sendData = {
        id: this.$route.query.id,
        carType: 2,
        userIdList: this.Ids,
        bankInfoList: this.bankInfoList,
      };
      this.submitLoading = true;

      this.$api.user.CompanyReferrerCarAdd(sendData).then((res) => {
        this.submitLoading = false;
        if (res.code == 0) {
          this.$message.success("通知成功");
          this.tipVisible = false;
          this.$parent.noteCard();

        } else {
          this.$message.error(res.msg);
        }
      });
      this.colseDrawer();
    },
    getBankList () {
      this.$api.manage.CooperativeBank().then((res) => {
        if (res.error === false) {
          this.BankList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    noteCard () {
      this.$parent.noteCard(true);
    },
    SetOpenCarState (formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return;
        let sendData = {
          id: this.id,
          state: this.form.state,
          remark: this.form.remark,
        };
        this.submitLoading = true;

        this.$api.user
          .CompanyReferrerCarSetOpenCarState(sendData)
          .then((res) => {
            this.submitLoading = false;
            if (res.error === false) {
              this.ServiceRecommendLogPage();
              this.stateDialogVisible = false;
              this.resetForm();
            } else {
              this.$message.error(res.msg);
            }
          });
      });
    },
    resetForm () {
      this.$nextTick(() => {
        this.form = {};
        this.$refs.form.clearValidate();
      });
    },
    // 设置开卡状态
    setCardState (row) {
      this.stateDialogVisible = true;
      this.id = row.id;
      this.resetForm();
    },
    // 通知开卡
    notifyCard () {
      if (this.Ids.length <= 0) {
        return this.$message.warning("请至少选择一条数据");
      }
      this.$confirm("确认再次通知开卡吗?", "提示", {
        confirmButtonText: "确 认",
        cancelButtonText: "关 闭",
        type: "warning",
      })
        .then(() => {
          this.SendMsgAgain();
        })
        .catch(() => { });
    },

    onSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return;
        // let sendData = {
        //   firstId: this.firstId,
        //   parentId: this.userForm.parentId ? this.userForm.parentId : "",
        // };
        // this.$api.user.UpdateUserApplyParent(sendData).then((res) => {
        // 
        //   if (res.error === false) {
        //     this.$message.success("保存成功");
        //     this.ServiceRecommendLogPage();
        //   } else {
        //     this.$message.error(res.msg);
        //   }
        //   this.userDialogVisible = false;
        //   this.resetForm();
        // });
      });
    },
    //获取列的隐藏数据
    saveSet (checkList, type) {
      if (checkList) {
        this.tableConfig = JSON.parse(JSON.stringify(checkList));
      }
      this.sortType = type;
      this.tableConfig.forEach((element) => {
        if (element.sortable) {
          element.sortable = type;
        }
      });
    },
    //计算表格高度
    getHeight (height) {
      this.tableHeight = height;
    },
    //获取数据
    ServiceRecommendLogPage () {
      this.loading = true;
      let sendData = {};
      sendData = {
        pageIndex: this.$refs.pagination.currentPage,
        pageSize: this.$refs.pagination.pageSize,
        bankId: this.searchForm.bankId,
        type: 6,
        createStartDate: this.searchForm.createStartDate,
        createEndDate: this.searchForm.createEndDate,

        keyWord: this.searchForm.keyWord,
      };

      this.$api.manage.ServiceRecommendLogPage(sendData).then((res) => {
        if (!res.error) {

          this.loading = false;
          this.tableData = res.data.data;
          this.total = res.data.count;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleSelectionChange (selection) {
      this.Ids = selection.map((v) => {
        return v.id;
      });
    },
    // 无人员数据
    personnelTip () {
      this.$confirm("暂无人员数据,请前往人员管理处添加人员!", "提示", {
        confirmButtonText: "前往人员管理",
        cancelButtonText: "关 闭",
        type: "warning",
      })
        .then(() => {
          this.$router.push("/personnelList");
        })
        .catch(() => { });
    },
  },
};
</script>
<style lang="less" >
.customer-list {
  .upload-demo {
    .el-upload {
      width: 100% !important;
    }
    .el-upload-dragger {
      width: 100% !important;
    }
  }
}
</style>
<style lang="less" scoped>
// .el-form-item__label {
//   width: 60px !important;
// }
.btn {
  margin-left: 15px;
}
.customer-list {
  .bankList {
    background-color: #fff;
    width: 300px;
    padding: 15px;
    border-right: 1px solid rgba(204, 204, 204, 0.555);
    .bank {
      border: 1px solid #ccc;
      padding: 10px;
      border-radius: 5px;
      img {
        width: 100%;
      }
      h3 {
        text-align: center;
      }
    }
  }
  .file,
  .table {
    width: 100%;
    .title {
      display: flex;
      align-items: center;
      .num {
        color: rgb(26, 210, 103);
        font-size: 22px;
        margin-right: 15px;
      }
    }

    .upload-demo {
      width: 100%;
      padding: 10px 70px;
      .el-upload-dragger {
        width: 100% !important;
      }
    }
    .result {
      padding: 10px 70px;
    }
  }

  .category {
    width: 200px;
    height: calc(100vh - 155px);
    background-color: #fff;
    border-radius: 6px;
    padding: 20px;
    margin-right: 20px;
    > div {
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      border-bottom: 1px solid #ddd;
      font-weight: bold;
      font-size: 15px;
      img {
        width: 16px;
        margin-right: 5px;
      }
    }
    li {
      margin-top: 12px;
      cursor: pointer;
      &:hover {
        color: var(--theme-black);
        text-decoration: underline;
      }
    }
    .tab-active {
      color: #87481f !important;
      text-decoration: underline !important;
    }
  }
  .customer-table-list {
    width: calc(100%);
    height: calc(100vh - 155px);
  }
}
</style>
